import Logo from "@core/layouts/header/components/common/Logo";
import { cn } from "@core/utils/domUtil";

export default function SimpleHeader() {
  return (
    <div className={cn("sticky top-0 right-0 left-0 z-50 h-[var(--mobile-header-height)] bg-white lg:h-[var(--pc-header-height)]")}>
      <div
        className={cn("transition-height absolute top-0 left-0 h-[var(--mobile-header-height)] w-full overflow-hidden bg-white shadow-[0px_2px_30px_rgba(0,0,0,0.1)] lg:h-[var(--pc-header-height)]")}
      >
        <div className="flex h-[var(--mobile-header-height)] items-center justify-center px-[10px] lg:h-[var(--pc-header-height)] lg:px-[30px]">
          <Logo />
        </div>
      </div>
    </div>
  );
}
